import i18n from 'i18next'
import Backend from 'i18next-http-backend'
// import Cache from 'i18next-localstorage-cache';
// import postProcessor from 'i18next-sprintf-postprocessor';
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

i18n
  .use(Backend)
  // .use(Cache)
  .use(LanguageDetector)
  .use(initReactI18next)
  // .use(postProcessor)
  .init({
    fallbacking: 'en', // by default choosing language as a english
    debug: false, // for debugging, it should be false on production
    interpolation: {
      escapeValue: false // to avoid cross site scrpting issues
    }
  })

export default i18n